export default "__VITE_ASSET__eiWOa8Rm__"